import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { ArticleStockService } from "../../../service/articleDelivery/ArticleStockService";
import ArticleStockResponse from "../../../model/articleDelivery/ArticleStockResponse";


class ArticleStockSelectStore {

    public loading: boolean;
    public commonStore: CommonStore;
    public elements: ArticleStockResponse[];
    public filteredElements: ArticleStockResponse[];
    public selectedElement: ArticleStockResponse | undefined;
    public entityId: string;
    public isSearchDialogOpen: boolean;

    constructor(commonStore: CommonStore, entityId: string, selectedElement?: ArticleStockResponse) {
        this.loading = false;
        this.commonStore = commonStore;
        this.elements = [];
        this.filteredElements = [];
        this.entityId = entityId;
        this.selectedElement = selectedElement;
        this.isSearchDialogOpen = false;
        makeAutoObservable(this);
    }

    @action
    public async search(): Promise<void> {
        this.loading = true;
        const response = await ArticleStockService.getFromEntity(1, 1000, this.entityId);
        if (response.success) {
            runInAction(() => {
                this.elements = response.data?.data.filter(t => t.amount > 0) || [];
                this.filteredElements = [...this.elements];
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public toggleSearchDialog(value?: boolean) {
        value = (value === undefined) ? !this.isSearchDialogOpen : value;
        this.isSearchDialogOpen = value;
        if (this.isSearchDialogOpen) {
            this.search();
        }
    }

    get isEmpty(): boolean {
        return this.elements.length === 0;
    }

    @action
    public async filter(filter: string) {
        this.filteredElements = this.elements.filter(e => e.articleName.toLowerCase().includes(filter.toLowerCase()));
    }

    @action
    public async setSelectedElement(element?: ArticleStockResponse) {
        this.selectedElement = element;
        this.isSearchDialogOpen = false;
    }

}

export default ArticleStockSelectStore;